module.exports = __webpack_public_path__ + "static/media/block_fi.9d7d7941.svg";